import PropTypes from 'prop-types';
import React from 'react';
import MetaDataWrapper from 'modules/Common/containers/MetaDataWrapper';

import { localLongDate } from 'utils/LocalDateTimeHelper';
import { Link } from 'react-router';
import { toSlug } from 'utils';

export default function HorseRacingGoing(props) {
  require("./HorseRacingGoing.scss");

  const title = "Going";

  if (!props.races) {
    return (
      <div className="hr-racing-racecards">
        <p className="hr-racing-racecards-error-message">There has been a problem displaying the race information.</p>
      </div>
    );
  }


  return <div className="horse-racing-going">
    <MetaDataWrapper title={title}/>
    <h1 className="page-main-title">{title}</h1>
    <table className="hr-going-date-table">
      {Object.keys(props.races).sort().map(date => <tbody key={date}>
        <tr className="hr-going-date-header">
          <th colSpan="2">{localLongDate(date)}</th>
        </tr>
        <tr>
          <th>Meeting</th>
          <th>Going</th>
        </tr>
        {props.races[date].map(({
          course: {name},
          meeting_reference: {id},
          going = "-",
          date: meetingDate
        }) => <tr key={id}>
          <td><Link to={`/racing/meeting/${meetingDate}/${toSlug(name)}/${id}`}>{name}</Link></td>
          <td>{going}</td>
        </tr>)}
      </tbody>)}
    </table>
  </div>
}

HorseRacingGoing.propTypes = {
  races: PropTypes.object
};



// WEBPACK FOOTER //
// ./modules/HorseRacing/components/HorseRacingGoing.js